import './Button.css';

import type { ComponentProps, FunctionComponent } from 'react';

import type { Icon } from '../Icons/types';
import { Loader } from '../Loader/Loader.component.tsx';

type ButtonTheme = 'primary' | 'secondary' | 'tertiary';
type ButtonSize = 'small' | 'medium' | 'large';

const SMALL_BUTTON_ICON_SIZE = 20;
const MEDIUM_LARGE_BUTTON_ICON_SIZE = 24;

const SIZE_TYPOGRAPHY_MAPPING: Record<ButtonSize, string> = {
  small: 'text-sm',
  medium: 'text-base',
  large: 'text-lg',
};

export interface ButtonProps extends ComponentProps<'button'> {
  label?: string;
  RightIcon?: Icon;
  theme: ButtonTheme;
  size: ButtonSize;
  isLoading?: boolean;
}

export const Button: FunctionComponent<ButtonProps> = ({
  label,
  RightIcon,
  theme,
  size,
  onClick,
  isLoading = false,
  ...props
}) => {
  return (
    <button
      className={`button button-${theme} button-${size} ${label === undefined ? 'icon-button' : ''}`}
      onClick={isLoading ? undefined : onClick}
      {...props}
    >
      {label && (
        <p className={`${SIZE_TYPOGRAPHY_MAPPING[size]} semibold`}>{label}</p>
      )}
      {isLoading ? (
        <Loader color="current-color" size="small" />
      ) : (
        RightIcon && (
          <RightIcon
            size={
              size === 'small'
                ? SMALL_BUTTON_ICON_SIZE
                : MEDIUM_LARGE_BUTTON_ICON_SIZE
            }
          />
        )
      )}
    </button>
  );
};
